import { useMutation } from "@tanstack/react-query";
import axiosBaseURL from "../index";

export const useSubscribe = () => {
  return useMutation({
    mutationFn: async (data: {
      name: string;
      shortName: string;
      email: string;
      phoneNumber: string;
      type: string;
      address: any;
      contactPerson: {
        fullName: string;
        username: string;
        email: string;
        password?: string;
        phoneNumber: string;
      };
    }) => {
      const subscribtionData = {
        ...data,
        reInsurerName: null,
        parentOrganization: null,
        reInsurerEmail: null,
      };
      const result = await axiosBaseURL.post(`fe/subscribe`, subscribtionData);

      return result;
    },
  });
};
